import CompletePayment from "./CompletePayment";

export default CompletePayment;